import Vue from 'vue'
import Vuex from 'vuex'
// import mall from './modules/mall'
import activity from './modules/activity'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // mall,
    activity
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js